(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sanctale-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const video = document.querySelector('.sanctale-arrival__video');
    if (!video) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const fadeWindow = 0.55;

    const syncPlayback = () => {
      if (reduceMotion.matches) {
        video.pause();
        video.removeAttribute('autoplay');
        video.style.opacity = '0';
        return;
      }
      video.style.opacity = '1';
      video.setAttribute('autoplay', '');
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const softenLoop = () => {
      if (reduceMotion.matches || !video.duration || Number.isNaN(video.duration)) return;
      const remaining = video.duration - video.currentTime;
      if (remaining <= fadeWindow) {
        video.style.opacity = String(Math.max(remaining / fadeWindow, 0));
        return;
      }
      if (video.currentTime <= fadeWindow) {
        video.style.opacity = String(Math.min(video.currentTime / fadeWindow, 1));
        return;
      }
      video.style.opacity = '1';
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncPlayback, { once: true });
    } else {
      syncPlayback();
    }

    video.addEventListener('timeupdate', softenLoop);
    video.addEventListener('playing', softenLoop);

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', syncPlayback);
    } else if (typeof reduceMotion.addListener === 'function') {
      reduceMotion.addListener(syncPlayback);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
